<template>
  <div>
    <h1 
      :class="`infinity-text ${textColor}`"
      style="display: flex; align-items: center"
    >
      <v-icon
        large
        class="ma-2"
        :color="color"
        v-html="icon"        
      />
      {{ text }}
      <div class="ml-4">
        <slot />
      </div>
    </h1>
    <v-divider />
  </div>
</template>
<script>
  export default {
    name: 'InfinitySeparator',
    props: {
      icon: String,
      text: String,
      color: String,
      textColor: String,
    },
  }
</script>
<style scoped>
  .infinity-text {
    font-family: lato;
    font-weight: bold;
    letter-spacing: initial;
  }
</style>
